import React, { useState, useEffect, useCallback, useMemo } from 'react';
import DataTable from '../Components/DataTable/DataTable';
import Card from 'react-bootstrap/Card';
import Button from 'react-bootstrap/Button';
import Modal from 'react-bootstrap/Modal';
import Controllers from '../Api/Controllers';
import { FormCustom, Input, CheckBox } from '../Components/Form/Form';
import Helpers from '../Helpers/Helpers';
import { toast as toastr } from 'react-toastify';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Tooltip from 'react-bootstrap/Tooltip';
import { useSelector } from 'react-redux'

const EntityForm = ({ data, onSubmit, viewDisabled }) => {
  const { id = '', description = '', state = 1, entity_logo = '' } = data
  const [row, setRow] = useState({ id, description, state, entity_logo })
  const [file, setFile] = useState(null)

  const dataSumbit = useCallback(() => {
    return {
      p_id: row.id,
      p_description: row.description,
      p_state: parseInt(row.state)
    }
  }, [row])

  return <FormCustom dataSubmit={dataSumbit()} viewSubmit={!viewDisabled} onSubmit={onSubmit}>
    <Input
      text="Descripción"
      placeholder="Descripción"
      classNameParent="col-12 mb-2"
      icon="far fa-comment-alt"
      required
      defaultValue={description}
      onChange={e => setRow({ ...row, description: e.currentTarget.value })}
      disabled={viewDisabled}
    />
    <div className="col-12 mb-2">
      <label className="mb-1"><i className="fa fa-image mr-2"></i>Logo de entidad</label>
      <input type="file" accept="image/*" className="form-control" disabled={viewDisabled} onChange={e => setFile(e.currentTarget.files.length ? e.currentTarget.files[0] : null)} />
      {row.entity_logo ? <div className="mt-2"><img alt="logo" src={`${Helpers.config.api.images}/entity/${row.entity_logo}`} style={{ maxHeight: 80 }} /></div> : ''}
    </div>
    <CheckBox
      text="Activo"
      classNameParent="col-12 mb-2"
      defaultChecked={parseInt(state) === 1}
      onChange={e => setRow({ ...row, state: e.currentTarget.checked ? 1 : 0 })}
      id="state-entity"
      disabled={viewDisabled}
    />
  </FormCustom>
}

const Entity = () => {
  const permissions = useSelector(store => store.session.permissions)
  const actionsModule = Helpers.getActions({ permissions, name: 'entidades' })

  const nameModulo = 'Entidades'
  const namePage = 'Entidad'
  const nameController = 'entity'

  const [rows, setRows] = useState([]);
  const [isProcessing, setIsProcessing] = useState(true);
  const [modalSize, setModalSize] = useState('');
  const [modalShow, setModalShow] = useState(false);
  const [modalHeader, setModalHeader] = useState('');
  const [modalTitle, setModalTitle] = useState('');
  const [form, setForm] = useState('');
  const [reload, setReload] = useState(true);

  useEffect(() => {
    if (reload) {
      Controllers[nameController]['get_' + nameController]().then(res => {
        setRows(res.data)
      })
      .finally(() => {
        setIsProcessing(false)
        setReload(false);
      });
    }
  }, [reload])

  const handleUpdate = useCallback(e => {
    const { id = '', disabled = 0 } = e.currentTarget.dataset;
    let button = e.currentTarget
    let buttonHTML = button.innerHTML;
    button.innerHTML = Helpers.icon.spin()

    setModalTitle(parseInt(disabled) === 1 ? <><i className={'mr-2 ' + (actionsModule.view ? actionsModule.view.icon : 'fa fa-eye')}></i>{actionsModule.view ? actionsModule.view.description : 'Ver'} {namePage}</> : (id ? <><i className={'mr-2 ' + (actionsModule.update ? actionsModule.update.icon : 'fa fa-pen')}></i>{actionsModule.update ? actionsModule.update.description : 'Editar'} {namePage}</> : <><i className={'mr-2 ' + (actionsModule.create ? actionsModule.create.icon : 'fa fa-plus')}></i>{actionsModule.create ? actionsModule.create.description : 'Crear'} {namePage}</>))
    setModalSize('md');
    setModalHeader('');

    if (id) {
      Controllers[nameController]['get_' + nameController + '_id']({ p_id: id }).then(res => {
        setForm(<EntityForm data={res.data} viewDisabled={parseInt(disabled) === 1} onSubmit={onSubmit} />);
        setModalShow(true);
      }).catch(req => {
        Helpers.promise.catch({ req, toastr });
        setModalShow(false);
      }).finally(() => button.innerHTML = buttonHTML)
    } else {
      setForm(<EntityForm data={{}} viewDisabled={parseInt(disabled) === 1} onSubmit={onSubmit} />);
      setModalShow(true);
      button.innerHTML = buttonHTML
    }
  }, [actionsModule])

  const onSubmit = ({ e, dataSubmit, callbackSuccess }) => {
    let $this = e.currentTarget

    let propsValidateForm = { form: $this, toastr };
    if (!$this.checkValidity()) {
      $this.classList.add('was-validated');
      Helpers.form.isFormCorrect(propsValidateForm);
      return;
    } else {
      $this.classList.remove('was-validated');
      if (!Helpers.form.isFormCorrect(propsValidateForm)) {
        return;
      }
    }

    let button = $this.querySelector('button[type=submit]');
    let buttonHTML = button.innerHTML
    button.innerHTML = Helpers.icon.spin();

    // decidir si enviar como archivo
    let hasFile = false
    let dataToSend = dataSubmit
    if (form && form.props && form.props.data) {
      // noop
    }
    const inputFile = $this.querySelector('input[type=file]')
    if (inputFile && inputFile.files && inputFile.files.length) {
      hasFile = true
      let fd = new FormData()
      Object.keys(dataSubmit).forEach(k => fd.append(k, dataSubmit[k]))
      fd.append('p_entity_logo', inputFile.files[0])
      dataToSend = fd
    }

    Controllers[nameController][nameController + '_insert_update'](dataToSend, hasFile).then(res => {
      Helpers.toastr.construct({ response: res.response, message: res.message, toastr });
      callbackSuccess && callbackSuccess(res.data)
      if (res.response === 'success') {
        setModalShow(false);
      }
    }).catch(req => {
      Helpers.promise.catch({ req, toastr });
    }).finally(() => {
      button.innerHTML = buttonHTML;
      setReload(true)
    });
  }

  const onDelete = e => {
    const { id = '' } = e.currentTarget.dataset;
    setModalTitle(<><i className="fa fa-trash mr-2"></i> Eliminar {namePage}</>);
    setModalHeader('bg-danger');
    setModalSize('sm');
    setForm(<div className="d-flex flex-column align-items-center">
      <p><strong>¿Eliminar {namePage} #{id}?</strong></p>

      <div>        
        <Button variant="danger" className="mr-2" size="sm" onClick={e => {
          let button = e.currentTarget
          let buttonHTML = button.innerHTML;
          button.innerHTML = Helpers.icon.spin()

          Controllers[nameController][nameController + '_delete']({
            p_id: id
          }).then(res => {
            Helpers.toastr.construct({ response: res.response, message: res.message, toastr });
          }).catch(req => {
            Helpers.promise.catch({ req, toastr });
          }).finally(() => {
            button.innerHTML = buttonHTML;
            setReload(true)
            setModalShow(false);
          });
        }}>
          <i className="fa fa-check mr-2"></i>Si
        </Button>
        <Button variant="dark" className="mr-2" size="sm" onClick={() => setModalShow(false)}>
          <i className="fa fa-times mr-2"></i>No
        </Button>
      </div>
    </div>);
    setModalShow(true)
  }

  const dtRows = useMemo(() => {
    const thead = [
      { name: 'ID', align: 'center' },
      { name: 'Descripción' },
      { name: 'Estado', align: 'center' },
      { name: 'Acc.', align: 'center' }
    ];

    return <DataTable
      isProcessing={isProcessing}
      tbody={rows}
      thead={thead}
      render={tbody => tbody.map(r => {
        const columns = [
          <td align="center">{r.id}</td>,
          <td>{r.description}</td>,
          <td align="center"><strong className={'text-' + (parseInt(r.state) === 1 ? 'success' : 'danger')}>{parseInt(r.state) === 1 ? 'ACTIVO' : 'INACTIVO'}</strong></td>
        ];
        columns.push(<td align="center">
          {actionsModule.view ? <OverlayTrigger placement="top" overlay={props => <Tooltip {...props}>{actionsModule.view.description}</Tooltip>}>
            <Button variant={actionsModule.view.color} data-disabled={1} size="xs" className="mr-1" data-id={r.id} onClick={handleUpdate}>
              <i className={actionsModule.view.icon}></i>
            </Button>
          </OverlayTrigger> : ''}
          {actionsModule.update ? <OverlayTrigger placement="top" overlay={props => <Tooltip {...props}>{actionsModule.update.description}</Tooltip>}>
            <Button variant={actionsModule.update.color} size="xs" className="mr-1" data-id={r.id} onClick={handleUpdate}>
              <i className={actionsModule.update.icon}></i>
            </Button>
          </OverlayTrigger> : ''}
          {actionsModule.delete ? <OverlayTrigger placement="top" overlay={props => <Tooltip {...props}>{actionsModule.delete.description}</Tooltip>}>
            <Button variant={actionsModule.delete.color} size="xs" data-id={r.id} onClick={onDelete}>
              <i className={actionsModule.delete.icon}></i>
            </Button>
          </OverlayTrigger> : ''}
        </td>);
        return (<tr>{React.Children.toArray(columns)}</tr>);
      })}
    />
  }, [isProcessing, rows, handleUpdate, actionsModule])

  return <>
    <Card>
      <Card.Header className="justify-content-between">
        <span>Listado De {nameModulo}</span>
        {actionsModule.create ? <Button onClick={handleUpdate} variant={actionsModule.create.color} size="sm"><i className={ actionsModule.create.icon}></i><span className="ml-2 d-none d-md-inline-block">{actionsModule.create.description} {namePage}</span></Button> : ''}
      </Card.Header>
      <Card.Body>
        {dtRows}
      </Card.Body>
    </Card>
    <Modal show={modalShow} onHide={() => setModalShow(false)} size={modalSize} backdrop="static">
      <Modal.Header closeButton className={modalHeader}>
        <Modal.Title as="div">{modalTitle}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        {form}
      </Modal.Body>
    </Modal>
  </>
}

export default Entity;


